<template>
  <div :class="tclass">
	<p v-html="texts[index-1]"></p>
  </div>
</template>

<script>
export default {
    name: "tSection",
    props: {
        index: {
            type: Number,
            require: true
        }

    },
    computed: {
        tclass() {
            if(this.index == 1 ||this.index == 14 || (this.index >=21 && this.index <= 30)){
                return "pureWhite"

            } else if (this.index == 2 || this.index == 3){
                return "gray"
            } else if(this.index <=13 || this.index <=20  ||this.index == 26){
                return "banana"

            } 
            return "pureBlack"
        }
    },
    data() {
        return{
            texts : [
                `<h2>공상 여행을 떠나시겠습니까?</h2>
심리테스트 형식의 예술 프로젝트
	`,
                `여기 회색인간이 있습니다.<br/>
현실에 지쳐<br/>
본인의 색깔을 잃어버린 존재죠.`,
                `어느 날,<br/>
바닥을 보며 터벅터벅 걷던 회색 인간은<br/>
바닥에 떨어진 무언가를 발견합니다.`,
                `“안녕하세요 <br/>
 베란다토마토의 공상티켓입니다”`,
                `공상을 하며 시간을 보내볼까요?<br/>
멍때리며 시간을<br/>
 흘릴 공상 티켓이 주어졌으니 말이죠`,
                `내 맘같지 않을 때`,
                `위로가 필요한 그런날`,
                `꼬여버린 끈처럼<br/>
 자꾸 뭔가 잘못되어가는것같고 `,
                `다음 날을<br/>
마주할 준비가 되지않았는데<br/>
또 다음 계절이 와버릴까 <br/>
걱정이 되는 날`,
                `그런 후회와 걱정이 늘어가는 날`,
                `그런날은<br/>
아무리  피곤해도<br/>
잠이오질 않더라구요`,
                `당신도 혹시 그런 날을 마주하고있다면<br/>
공상티켓을 들고 잠시 놀러오셔요`,
                `이곳은 언제나 당신을 환영한답니다.`,
                `그러더니 <br/>
어디선가 노랫소리가 들립니다.`,
                `틱틱타카토<br/>
멋진 유리 구두를 신고 `,
                `룰루랄라<br/>
 모두를 춤추게하는 <br/>
댄싱쥬스가 되볼까 `,
                `외계에 사는 존재를 그려보다가`,
                `저 반짝이는 달로 날아가볼까<br/>
 나는 그곳에서 반짝이는 빛에 <br/>
맞춰 노래를 부를꺼야 `,
                `그러다가<br/>
 친구를 만나게 되면 `,
                `해를 닮은<br/>
 뜨거운 미소로 인사를 보내보자 `,
                `회색인간의 색깔을 되찾기 위한<br/>
공상세계로의 여행 <br/>
함께 떠나볼까요?`,
                `앞내용은 이민아작가의<br/>
 베란다토마토 프로젝트 책,<br/>
 몽상티켓 에서 발췌하였습니다.`,
                ` 회색인간과 공상여행을<br/>
 떠나기 위한 기차를 탔습니다`,
                "",
                `“나는 이런 것들이 고민이야”<br/>
회색인간은 한숨을 푹 내쉽니다.`,
                "",
                `드디어 기차가 목적지에 도착했습니다`,
                ``,
                `주변을 두리번거리던 그 때<br/>
 공상티켓에서 보았던 <br/>
베란다토마토가 다가와 말을 겁니다`,
                ``,
                `회색인간과 가볍게 발걸음을 옮겨 보는 당신<br/>
무언가 반짝이는 것이 보입니다.`,
                '',
                `문을 열어 회색인간과 함께<br/>
 안으로 들어가봅니다. <br/>
문 안쪽 세상은 너무나도 아름답고 <br/>
평화로워 마치 천국에 온 것 같은<br/>
 기분이 듭니다`,
                '',
                `정원은 형형색색의 반짝이는 열매로<br/>
 가득차 있습니다.`,
                '',
                `회색인간과 정원 곳곳을 뛰어다니며 놀던 중,<br/>
 신비한 호수를 발견합니다.`,
                ''
                ,`베란다토마토가 <br/>
둥둥 하늘로 날아오릅니다.<br/>
그러자  매우 좋은 향기가 납니다. `,
                '',
                `이제 현실로<br/>
다시 돌아갈 시간이에요  `,
                '',
                `현실세계에 도착한 회색인간과 당신. <br/>
이제 회색인간과도 작별할 시간입니다. <br/>
회색인간이 말합니다.`,
                '',
                '',
                '',
                '',
                '회색인간의 본래 색깔은..',
                `안녕하세요<br/>
이 심리테스트는 <br/>
공상의 세계로 초대하여 <br/>
지친하루를 위로하기 위한 작품들을 <br/>
제작하는 시각예술작가 이민아의<br/>
 상상으로부터 출발했습니다.<br/>
 새벽에 마시는 <br/>
따뜻한 레몬차같은<br/>
 위로가 필요하다면,<br/>
 내일은 더 바삭바삭하고 <br/>
새콤달콤한 하루를 맞이하길 원한다면 <br/>
이민아 작가의 사이트를 방문해주세요<br/>
 <a href="https://www.oxmlox.com" target="_blank">www.oxmlox.com</a><br/>
<a href="https://www.instagram.com/veranda_tomato/" target="_blank">@veranda_tomato</a><br/>
<a href="https://www.instagram.com/oxmlox/" target="_blank">@oxmlox</a>`,
                `후원 / 서울문화재단, 사획적기업 위누 <br/>
기획/ 이민아. 김주희 <br/>
그림 / 이민아 <br/>
글 / 김주희@artext_juhee , 이민아 <br/>
디자인 /이민아@veranda_tomato<br/>
개발 / 이재규 @gaekyul`,
                `<h2>빨강인간</h2><br/>
회색인간의 본래 색깔은 빨간색입니다. <br/>
매사에 열정이 넘치는 당신 덕분에<br/>
 회색인간이 본래의 모습을<br/>
 되찾을 수 있었어요!<br/>
 매사에 열정이 넘치는 당신은 <br/>
일상에서 활력이 넘치고,<br/>
 새로운 일에 도전하는 것에도<br/>
 거침이 없으며,<br/>
 사랑할 때에도 누구보다도 뜨겁습니다. <br/>
특유의 긍정적이고 생기 있는 에너지가<br/>
 주변 사람들에게도 전파되어 <br/>
활력소 역할을 하죠.<br/>
 하지만 태양빛이 너무 뜨거우면 <br/>
생명력이 없는 사막이 되어 버리는 것처럼,<br/>
지나친 열정 뒤에는<br/>
 종종 우울과 무기력함이 동반되기도 합니다.<br/>
 격렬한 감정에 휩싸일 때는<br/>
 감정으로부터 <br/>
한 발자국 떨어져서 일기를 쓰며<br/>
 자신의 마음을 위로해보세요.<br/>
열정적인 당신의 일상을 응원합니다!`,
                `<h2>노랑인간</h2><br/>
회색인간의 본래 색깔은 노란색입니다.<br/>
 이루고 싶은 꿈이 <br/>
무궁무진한 당신 덕분에 <br/>
회색인간이 본래의 모습을 <br/>
되찾을 수 있었어요!<br/>
어린아이처럼 순수한 마음을 지닌<br/>
 당신은 해보고 싶은 것, <br/>
이루고 싶은 것이 많은 꿈쟁이입니다.<br/>
 새콤달콤 발랄한 성격 덕분에 <br/>
 덕분에 주변 사람들<br/>
 역시 당신에게 <br/>
큰 호감을 가지고 있답니다.<br/>
하지만 봄이 되어<br/>
 노오란 개나리가 피기만을 <br/>
계속 기다리고 있으면<br/>
 겨울이 더 길게 느껴지는 것처럼, <br/>
꿈과 현실과의 괴리 속에서<br/>
 종종 힘들어하기도 합니다.<br/>
 당신의 꿈이 허무맹랑하게 느껴진다면 <br/>
다른 사람들과 이야기를 나누며<br/>
 현실적이고 구체적인 조언을 구해보세요.<br/>
 꿈꾸는 당신의 일상을 응원합니다!`,
                `<h2>초록인간</h2><br/>
회색인간의 본래 색깔은 초록색입니다. <br/>
항상 마음 속에 평화를 품고<br/>
 다니는 당신 덕분에<br/>
 회색인간이 본래의 모습을<br/>
되찾을 수 있었어요!<br/>
자연을 사랑하고 <br/>
일상에서의 힐링을 즐기는 당신은 <br/>
온화하고 평화로운 성격의 소유자입니다. <br/>
당신을 만나면<br/>
 치유받는 듯한 느낌이 들기 때문에 <br/>
주변 사람들이 항상 당신을 먼저 찾아오죠. <br/>
하지만 작은 씨앗이 큰 고목이 되기까지<br/>
 아주 오랜 시간이 걸리는 것처럼, <br/>
당신의 평화지향적인 성격은 <br/>
중간중간 나태함과 무기력함으로<br/>
 이어지기도 합니다.<br/>
단기적인 목표를 꾸준히 세우고 <br/>
하루하루 작은 성취들을 이뤄내며<br/>
 이를 기록해보세요.<br/>
 평화로운 당신의 일상을 응원합니다!
`,
                `<h2>파랑인간</h2><br/>
회색인간의 본래 색깔은 파란색입니다. <br/>
마음이 충만한 당신 덕분에 <br/>
회색인간이 본래의 모습을 <br/>
되찾을 수 있었어요!<br/>
바다와도 같이 넓은 마음을 가진 당신은<br/>
 관대하면서도 대범한 성격의 소유자로, <br/>
일상을 충실히 꾸리면서도 과감한 변화도<br/>
 맞이할 줄 아는 멋진 사람입니다. <br/>
이해심 깊은 당신의 마음 덕분에<br/>
 주변 사람들이 <br/>
고민이 있을 때면 <br/>
당신을 찾아와 위안을 얻고는 하죠.<br/>
 하지만 바다가 아무리 넓다 한들 <br/>
쓰레기를 버리면 오염되는 것처럼,<br/>
 너무 많은 것들을 포용하려다 보면<br/>
 당신의 마음이 지쳐버릴 수 있습니다. <br/>
아니라고 생각되는 것에는 과감하게 <br/>
“NO!”를 외치는 법을 연습해보세요. <br/>
충만한 당신의 일상을 응원합니다!<br/>
`,
                `<h2>보라인간</h2><br/>
회색인간의 본래 색깔은 보라색입니다. <br/>
일상 속에서도<br/>
 낭만을 즐길 줄 아는 당신 덕분에 <br/>
회색인간이 본래의 모습을<br/>
 되찾을 수 있었어요!<br/>
 가슴 깊은 곳 항상 로맨틱한<br/>
 낭만을 품고 사는 당신은<br/>
 예술을 사랑하고 삶을 진정으로<br/>
 즐길 줄 아는 멋쟁이입니다.<br/>
 당신의 매력적인 분위기와<br/>
 개성있는 취향에 끌려 <br/>
당신과 대화를 즐기고 싶은 사람들이<br/>
 주변에 속속 모여들죠. <br/>
하지만 보라빛 노을이 아름다운만큼 <br/>
사람들을 우수에 잠기게도 하는 것처럼,<br/>
 당신의 예민한 감수성은 때때로<br/>
 당신을 힘들게 만들기도 합니다.<br/>
 건강한 식사를 챙겨먹고 <br/>
운동을 꾸준히 하며 <br/>
규칙적인 일상을 보내기 위해<br/>
 노력해보세요.<br/>
 낭만적인 당신의 일상을 응원합니다!`
            ],
            style: [
	
            ]
        }
    }
}
</script>

<style>
.pureWhite {
  color: white;
}

.pureBlack {
  color: black;
}

.gray {
  color: black;
  background: rgba(255, 255, 255, 0.64);
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  margin: 15px 15px 0 15px;
  padding: 4px 5px 0px 5px;
}

.banana {
  color: black;
  background: #F9FFD7;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin: 15px 15px 0 15px;
  padding: 4px 5px 0px 5px;
}


</style>